import { useState } from 'react';
import { getDataWithToken, postDataWithToken, SHARE_TRIP_DETAILS_URL } from 'Utils/api';
import { TOAST_ERROR, TOAST_SUCCESS } from 'Constants/actionConstants';
import { store } from '../../../../index';

/**
 * Ported from the old tracking screen's GET_SHARE_DETAILS/SAVE_SHARE_DETAILS
 * sagas - same endpoint for fetch and save, and the same fire-and-forget
 * save (the old Share component closes itself immediately on Save without
 * waiting for this to resolve).
 */
export const useShareDetails = (tripId) => {
  const [shareDetails, setShareDetails] = useState({});

  const fetchShareDetails = () => {
    getDataWithToken(SHARE_TRIP_DETAILS_URL, { trip_id: tripId })
      .then((response) => setShareDetails((response && response.data) || {}))
      .catch((error) => console.log('[TripTrackingV2] share details error:', error));
  };

  const saveShareDetails = (data) => {
    const payload = { ...data, url: `${window.location.origin}/tracking-public/${tripId}`, trip_id: tripId };
    postDataWithToken(SHARE_TRIP_DETAILS_URL, payload)
      .then(() => store.dispatch({ type: TOAST_SUCCESS, message: 'Shared the Trip Details' }))
      .catch((error) => {
        console.log('[TripTrackingV2] save share details error:', error);
        store.dispatch({ type: TOAST_ERROR, message: (error && error.message) || 'Oops! Something went wrong' });
      });
  };

  return { shareDetails, fetchShareDetails, saveShareDetails };
};
